import { render, staticRenderFns } from "./RelatedAditionalsPanel.vue?vue&type=template&id=60e511d8&scoped=true"
import script from "./RelatedAditionalsPanel.vue?vue&type=script&lang=js"
export * from "./RelatedAditionalsPanel.vue?vue&type=script&lang=js"
import style0 from "./RelatedAditionalsPanel.vue?vue&type=style&index=0&id=60e511d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e511d8",
  null
  
)

export default component.exports